export default "__VITE_ASSET__e34078a2__"